import { Link } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import Detail from "../../Containers/AboutProduct/Detail";
import Footer from "../../Components/Footer";

export default function NotFound() {
    return (
        <div>
            <Navbar />
            <div className="content-wraper">
                <div style={{backgroundColor:"white",textAlign:"center", marginTop:30, padding:30}}>
                    <h1 style={{textAlign:"center"}}>Oops! La page que vous chercher n'existe pas.</h1>
                    <Link to='/'>Retourner à la page d'accueil</Link>
                </div>

            </div>
            <Footer />
        </div>

    )
}